export default __webpack_public_path__ + "d983a34b9e5c42edc71e46a7d5199ef1.png";